import axios from "axios";
import {DEV_ONLY, STAGING} from "@/constants";

const defaultBaseURL: string = `https://${DEV_ONLY ? 'develop.' : STAGING ? 'staging.' : ''}onchaintargeting.com/api.php/`;
// const defaultBaseURL: string = `https://onchaintargeting.com/api.php/`;
// const defaultBaseURL2: string = `http://localhost/onchaintargeting/api.php`;

const clientBuilder = (baseURL: string = defaultBaseURL) => {
  const client = axios.create({
    baseURL,
  });

  client.defaults.timeout = 60000;

  return client;
};

export default clientBuilder;
